import { DateUtil } from '@ddt-web/generic-utils';

import { ColumnConfig } from '../column-config';
import { ColumnText } from '../column-text';
import { SimpleExtractor } from '../extractors/simple-extractor';
import { StoreColumnExtractor } from '../extractors/store-column-extractor';
import { DateFormatter } from '../formatters';

export class InceptionDateDataLayerUtil {

	public static generateInceptionDateColumn = (storeId: string, dcrKey: string, isNetPerformance: boolean, id?: string): ColumnConfig<StoreColumnExtractor> => {
		return new ColumnConfig(
			new ColumnText(dcrKey, 'Inception Date'),
			null,
			new SimpleExtractor([storeId, 'associatedPortfolios'], (store, portfolio) => {
				const storePath = isNetPerformance ? 'netExPostMetrics' : 'exPostMetrics';
				if (store?.performance?.[storePath]?.[0].months < 180) {
					return store?.performance?.[storePath]?.[0]?.interval?.startDate;
				} else {
					return !store ? undefined : '-';
				}
			}),
			id,	// needed for pdf proportion calculation
			new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
		);
	};
}
